import { Button, Tooltip, Badge } from '@mui/material';

function ActionButton (props) {
	let onClick = props?.onClick;
	if(props?.onClick === undefined) {
		onClick = () => {};
	}
	return (
		<Tooltip title={props.title}>
			<Button onClick={onClick} disabled={props?.disabled ?? false} sx={{minWidth: 0}}>
                {props.badgeValue != null ? (
                    <Badge
                        badgeContent={props.badgeValue}
                        color="secondary"
                    >
                        {props.children}
                    </Badge>
                ) : (
                    props.children
                )}
			</Button>
		</Tooltip>
	);
}

export default ActionButton;
